import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";

import { ConfluenceTemplateMessages } from "@/components/confluence/templates/template-messages.ts";
import { wacToken } from "@/libraries/design/foundations";

const containerStyles = css({
    display: "flex",
    justifyContent: "center"
});

const variantHeaderStyles = css({
    flex: "1",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    borderRadius: "20px",
    marginBlock: "45px",
    paddingInline: "4px",
    width: "1304px",
    background: `url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg_atl_cloud_hero_small.svg) center/cover no-repeat`,
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#FFFFFF",
    height: "298px",
    marginInline: "78px",
    [media.below.lg]: {
        marginInline: "32px"
    },
    [media.below.sm]: {
        marginInline: "24px"
    },
    [media.below.xs]: {
        height: "296px",
        marginInline: "16px"
    }
});

const titleStyles = css({
    margin: "0",
    fontFamily: wacToken("font.charlie.display"),
    fontWeight: "500",
    fontSize: "52px",
    [media.below.sm]: {
        fontSize: "36px"
    }
});

const subTitleStyles = css({
    margin: "0",
    fontWeight: "400",
    fontSize: "20px",
    [media.below.sm]: {
        fontSize: "16px",
        width: "268px"
    }
});

export type TemplateHeroSectionProps = React.PropsWithChildren<{
    categoryName?: string;
}>;

const TemplateHeroSection = ({
    categoryName,
    children
}: TemplateHeroSectionProps) => {
    return (
        <div css={containerStyles}>
            <header css={variantHeaderStyles}>
                <h1 css={titleStyles}>
                    {categoryName ? (
                        <FormattedMessage
                            {...ConfluenceTemplateMessages.headerText}
                            values={{ categoryName }}
                        />
                    ) : (
                        <FormattedMessage
                            {...ConfluenceTemplateMessages.defaultHeaderText}
                        />
                    )}
                </h1>
                <p css={subTitleStyles}>
                    <FormattedMessage
                        {...ConfluenceTemplateMessages.subHeaderText}
                    />
                </p>
                {children}
            </header>
        </div>
    );
};
TemplateHeroSection.displayName = "TemplateHeroSection";
export { TemplateHeroSection };
